import enviro from 'enviro';
const REDDIT_ADS_APP_IDS = {
  QA: 34312717,
  PROD: 34878541
};
export const REDDIT_ADS_APP_ID = enviro.isQa() ? REDDIT_ADS_APP_IDS.QA : REDDIT_ADS_APP_IDS.PROD;
const CHATGPT_ADS_APP_IDS = {
  QA: 37951335,
  PROD: 40142985
};
export const CHATGPT_ADS_APP_ID = enviro.isQa() ? CHATGPT_ADS_APP_IDS.QA : CHATGPT_ADS_APP_IDS.PROD;